module.exports = __webpack_public_path__ + "static/img/jingying1.82517bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/jingying1.png
// module id = F28D
// module chunks = 0